import React, { useEffect, useState } from 'react'
import InfoPageService from 'services/InfoPageService'
import {
  BlogContent,
  BlogTitle,
  BlogWrapper,
  Description,
} from 'style/Blog.style'
import { data as contents } from './contents'

const InfoPage = props => {
  const slug = props.match.params.slug

  const pageContents = props?.route?.path

  const data = {
    title: '',
    content: '',
  }

  if (contents[pageContents]) {
    data.title = contents[pageContents].title
    data.content = contents[pageContents].content
  }

  return (
    <BlogWrapper withoutSidebar>
      <BlogContent>
        <BlogTitle>
          <h2>{data.title}</h2>
        </BlogTitle>
        <Description dangerouslySetInnerHTML={{ __html: data.content }} />
      </BlogContent>
    </BlogWrapper>
  )
}

export default InfoPage
